import { StorageData } from '~Components/Storage';
/**
 * Enum defining the different bong printing modes in BongGroup.tsx
 */
export enum BongPrintingMode {
  /**
   * Print separate ticket per course type for each printer station.
   * Example: 1 printer with stations "Food" and "Drinks" would print
   * separate tickets for each course type on each station.
   * This is the most granular printing mode.
   *
   * Triggers when: storage.bongGroupByStation && storage.bongPrintByStation
   */
  GROUP_BY_STATION_AND_PRINT_BY_STATION = 'GROUP_BY_STATION_AND_PRINT_BY_STATION',

  /**
   * Groups all printer stations together and prints a separate ticket per course type.
   * All stations are combined but each course type gets its own ticket.
   *
   * Triggers when: storage.bongGroupByStation && !storage.bongPrintByStation
   */
  GROUP_BY_STATION_ONLY = 'GROUP_BY_STATION_ONLY',

  /**
   * Print 1 ticket per printer station.
   * Example: 1 printer with stations "Food" and "Drinks" would print
   * 2 separate tickets, one for each station.
   * Can also be used to print copies of the same ticket if you add
   * two identical stations to the same printer.
   *
   * Triggers when: !storage.bongGroupByStation && storage.bongPrintByStation
   */
  PRINT_BY_STATION_ONLY = 'PRINT_BY_STATION_ONLY',

  /**
   * Default mode: Print 1 ticket with all printer stations combined.
   * This is the simplest mode - everything goes on one ticket.
   *
   * Triggers when: !storage.bongGroupByStation && !storage.bongPrintByStation
   */
  DEFAULT_COMBINED = 'DEFAULT_COMBINED',
}

/**
 * Determines which bong printing mode to use based on storage settings
 * @param storage - The storage data containing bong printing preferences
 * @returns The appropriate BongPrintingMode enum value
 */
export function getBongPrintingMode(storage: StorageData): BongPrintingMode {
  if (storage.bongGroupByStation && storage.bongPrintByStation) {
    return BongPrintingMode.GROUP_BY_STATION_AND_PRINT_BY_STATION;
  }

  if (storage.bongGroupByStation) {
    return BongPrintingMode.GROUP_BY_STATION_ONLY;
  }

  if (storage.bongPrintByStation) {
    return BongPrintingMode.PRINT_BY_STATION_ONLY;
  }

  // Default case: !storage.bongGroupByStation && !storage.bongPrintByStation
  return BongPrintingMode.DEFAULT_COMBINED;
}
